<template lang="pug">
  div
    h4 <kbd>行駛路肩報表</kbd>
    //-<h4 class="text-danger" v-if="department=='Admin'">
    //-  <input type="checkbox" v-model="isMerge">
    //-  <span>是否整合東西向數據報表</span>
    //-</h4> 
    div.custom-functions-wrapper
      div.custom-function(v-for="func in reportFunctions")
        h5  {{ func.name }}
        hr
        QueryFilter(
          :showDate="func.query_by_date"
          :showEventType="false" 
          :showSystem="false" 
          :showFilterButton="false"
          v-on:report="report($event, func.function_name, func.name, func.query_by_date)")
</template>

<script>
import FileSaver from 'file-saver';
import { webSocketServer } from '@/config';
import QueryFilter from './QueryFilter';
import axios from 'axios';

export default {
  name: 'ShoulderReport',
  components: {
    QueryFilter,
  },
  data() {
    return {
      reportFunctions: [],
      downloadProgress: undefined,
      department: this.$store.state.user.user.department.name,
      isMerge: false,
    };
  },
  computed: {
    instance() {
      return this.$store.getters.instance;
    },
  },
  methods: {
    dateFilled(emitPayload) {
      if ((emitPayload.start_date === undefined || emitPayload.start_date === '') || (emitPayload.end_date === undefined || emitPayload.end_date === '')) {
        return false;
      }
      return true;
    },
    getReportFunctions() {
      this.reportFunctions = [];
      this.instance.get('/api/report-functions/')
      .then((res) => {
        res.data.forEach((item) => {
          if (item.function_name.search("shoulder") !== -1 && item.on_status) {
            this.reportFunctions.push(item);
          }
        });
      });
    },
    connectWebSocket(filename) {
      return new Promise((resolve, rejects) => {
        const wb = new WebSocket(`${webSocketServer}/download-report/${this.$store.state.user.user.id}`);
        wb.onopen = () => {
          this.downloadProgress = 0;
          resolve(wb);
        };
        wb.onmessage = (res) => {
          const data = JSON.parse(res.data);
          if (data.error) {
            this.$store.commit('CLOSE_MESSAGE');
            this.$store.commit('SET_MESSAGE', {
              type: 'error',
              context: data.error,
            });
          }

          if (data.progress !== undefined) {
            this.downloadProgress = parseFloat(data.progress);
          }
          if (data.download_path !== undefined) {
            //this.instance.get(data.download_path, { responseType: 'blob' })
            //20200807 add
            axios.get(data.download_path, { responseType: 'blob' })
            .then((res) => {
              FileSaver.saveAs(res.data, `${filename}.xlsx`);
              this.$store.commit('SET_MESSAGE', {
                type: 'success',
                context: '下載成功',
              });
            });
            wb.close(); // close the socket after downloading
          }
        };
        wb.onclose = () => { rejects(wb); };
      });
    },
    downloadReport(params, functionName, FileName) {
      params.function_name = functionName;
      this.connectWebSocket(FileName).then((wb) => {
        wb.send(JSON.stringify(params));
      })
      .catch((wb) => {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '下載失敗' });
        wb.close();
      });
    },
    // downloadReport(emitPayload, functionName, FileName) {
    //   this.$store.commit('SET_MESSAGE', {
    //     type: 'warn',
    //     context: '下載中...',
    //   });
    //   emitPayload.function_name = functionName;
    //   this.instance.get('/export-report/', {
    //     params: emitPayload,
    //     responseType: 'blob',
    //   })
    //   .then((res) => {
    //     console.log('download success');
    //     FileSaver.saveAs(res.data, `AUTOIX-${FileName}.xlsx`);
    //     this.$store.commit('CLOSE_MESSAGE');
    //   })
    //   .catch((err) => {
    //     const reader = new FileReader();
    //     reader.addEventListener('loadend', (e) => {
    //       const eventCount = parseInt(e.srcElement.result, 10);
    //       if (eventCount > 0) {
    //         this.$store.commit('SET_MESSAGE', {
    //           type: 'error',
    //           context: '範圍資料過多，請縮小範圍',
    //         });
    //       }
    //       if (eventCount === 0) {
    //         this.$store.commit('SET_MESSAGE', {
    //           type: 'error',
    //           context: '範圍內無資料',
    //         });
    //       }
    //     });
    //     reader.readAsText(err.response.data);
    //   });
    // },
    report(emitPayload, functionName, FileName, useDate) {
      if(this.isMerge==false) {
        emitPayload.fixed_link_code_id = this.$store.state.user.user.department.fixed_link_code;
        emitPayload.isMerge = 0;  
      }
      else {
        emitPayload.fixed_link_code_id = this.$store.state.user.user.department.fixed_link_code;
        emitPayload.isMerge = 1;   
      } 
      if (useDate) {
        if (this.dateFilled(emitPayload) === false) {
          this.$store.commit('SET_MESSAGE', {
            type: 'error',
            context: '請確定已選填日期',
          });
        } else {
          this.downloadReport(emitPayload, functionName, FileName);
        }
      } else {
        this.downloadReport(emitPayload, functionName, FileName);
      }
    },
  },
  created() {
    this.getReportFunctions();
  },
  watch: {
    downloadProgress(val) {
      console.log(val);
      this.$store.commit('SET_MESSAGE', {
        context: `
        <h6>產生報告中</h6>
        <div class="progress">
          <div class="progress-bar progress-bar-striped" 
            role="progressbar" 
            style="width: ${val}%; background-color: #117a8b" 
            aria-valuenow="${val}" 
            aria-valuemin="0" 
            aria-valuemax="100">
          </div>
        </div>
        `,
        type: 'clean',
        confirm: false,
      });
    },
  },
};
</script>

<style lang="sass">
.custom-function
  width: 300px
  margin: 10px 10px
  display: inline-block

</style>



// WEBPACK FOOTER //
// ShoulderReport.vue?68c9adbf